import styled from 'styled-components';
import { CloseButtonInModal } from '../../../components/common/CloseButtonInModal';
import TransitioningModal from '../../../components/Modals/TransitioningModal';
import { desktopMediaQuery } from '../../../styleHelpers';
import { useImageRetry } from '../../../hooks/chat/useChatHelpers';
import { PLACEHOLDER_IMAGE_PATH } from '../../../components/ImageStuff/GeneratedImage';
import { useCharacter } from './CharacterContext';

interface CreatedCharacterModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const CreatedCharacterModal = ({
  show,
  setShow,
}: CreatedCharacterModalProps) => {
  const { character } = useCharacter();
  const { handleImageLoadError, retryEnabledImageUrl } = useImageRetry(
    character._imageUrl ?? PLACEHOLDER_IMAGE_PATH,
  );

  const handleClose = () => setShow(false);

  const transformName = (name: string) => {
    return name.replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  const name = transformName(character.name ?? 'Mia');

  return (
    <Modal
      isOpen={show}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 100,
        },
        content: {
          position: 'relative',
          padding: '16px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          border: 'none',
          width: '90vw',
          maxWidth: '800px',
          height: '90vh',
          margin: 'auto',
          marginTop: '1vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      ariaHideApp={false}
      shouldFocusAfterRender={false}
      onRequestClose={handleClose}
    >
      <CloseButtonInModal onClick={handleClose} />
      <CharacterNameTitle>{name}</CharacterNameTitle>
      <ImageContainer>
        <ResponsiveImage
          src={retryEnabledImageUrl}
          alt={`Character ${name}`}
          onError={handleImageLoadError}
        />
      </ImageContainer>
    </Modal>
  );
};

const Modal = styled(TransitioningModal)`
  display: flex;
  flex-direction: column;
  z-index: 3;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const ResponsiveImage = styled.img`
  max-height: 85vh;
  max-width: 90%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;

  ${desktopMediaQuery} {
    max-height: 85vh;
    max-width: 95%;
  }
`;

const CharacterNameTitle = styled.h2`
  font-size: 24px;
  margin: 2px 0 16px 0;
  text-align: center;
  color: inherit;

  ${desktopMediaQuery} {
    font-size: 28px;
  }
`;

export default CreatedCharacterModal;
